(function() {
  function init() {

    /* FAQ scroll reveal */
    var faqItems = document.querySelectorAll('[id$="__faq_JDc6wH"] .faq-details');
    if (faqItems.length) {
      var faqObs = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting) return;
          var idx = Array.from(faqItems).indexOf(entry.target);
          setTimeout(function() {
            entry.target.classList.add('noxor-visible');
          }, idx * 100);
          faqObs.unobserve(entry.target);
        });
      }, { threshold: 0.1 });
      faqItems.forEach(function(el) { faqObs.observe(el); });
    }

    /* Contact methods scroll reveal */
    var cards = document.querySelectorAll('[id$="__contact_methods"] .multicolumn-list__item');
    if (cards.length) {
      var cardsObs = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting) return;
          var idx = Array.from(cards).indexOf(entry.target);
          setTimeout(function() {
            entry.target.classList.add('noxor-visible');
          }, idx * 200);
          cardsObs.unobserve(entry.target);
        });
      }, { threshold: 0.15 });
      cards.forEach(function(el) { cardsObs.observe(el); });
    }

    /* Form scroll reveal */
    var form = document.querySelector('[id$="__form"] .contact-form');
    if (form) {
      var formObs = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('noxor-visible');
          formObs.unobserve(entry.target);
        });
      }, { threshold: 0.1 });
      formObs.observe(form);
    }

  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();
